import React, { useEffect, useState } from 'react'
import { Container, Button, Col, Row, Card, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, Input, } from 'reactstrap'
import { connect } from 'react-redux';
import BackButton from '../../../../../../../../designUtils/Logo/BackButton.svg'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import ReactTable from 'react-table';
import FetchAllCMOriginalFilesByAssetIdentifierService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchAllCMOriginalFilesByAssetIdentifierService';
import UploadCMAssetsService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/UploadCMAssetsService';
import FetchCMProductDataService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';
import NewCMProductListScreen from '../AssetAnnotations/NewCMProductListScreen';
import NewTaskIcon from '../../../../../../../../designUtils/OpsDashboard/MyTasks/NewTaskIcon.svg';
import UploadCMOnlineDocService from '../../../../../../../../Service/DashboardServices/ContentManagementServices/UploadCMOnlineDocService';

function UploadAllTypeOfPDAssetsFile(props) {
  const [isCheckedImg, setIsCheckedImg] = useState(false);
  const [isCheckedAi, setIsCheckedAi] = useState(false);
  const [loadingButton,setLoadingButton]=useState(false)
  const [selectedImageFiles, setSelectedImageFiles] = useState([]);
  const [selectedGraphicFiles, setSelectedGraphicFiles] = useState([]);
  const [dragging, setDragging] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertMessageAi, setAlertMessageAi] = useState('');
  const [allOriginalFiles, setAllOriginalFiles] = useState([]);
  const [handleLinkFile, setHandleLinkFile] = useState(false);
  const [storeName,setStoreName]= useState()
  const [productList, setProductList] = useState(false);
  const [asinList,setAsinList] =useState([])
  const [addProductsPopup, setAddProductsPopup] = useState(false)
  const [assetUrl, setAssetUrl] = useState('');
  const [uploadOption, setUploadOption] = useState(''); 
  const [selectedDestinationSubCategories, setSelectedDestinationSubCategories]=useState()
  const [fileName, setFileName] = useState("");
  const [isValidAssetUrl, setIsValidAssetUrl] = useState(true);
  const [onlineDocumentLink, setOnlineDocumentLink] = useState(false);

  const validateLink = (link) => { 
    try {
      new URL(link);
      return true;
    } catch (_) {
      return false;
    }
  };
  
  
  const handleAssetUrlChange = (e) => {
    const value = e.target.value;
    setAssetUrl(value);
    setOnlineDocumentLink(true);
    if (value.trim() === '') {
      setIsValidAssetUrl(false);
    } else {
      const isValid = validateLink(value);
      setIsValidAssetUrl(isValid);
    }
  };
  
  const handleRemoveFile = (file) => {
    const updatedFiles = selectedImageFiles.filter((f) => f !== file);
    setSelectedImageFiles(updatedFiles);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const allowedExtensions = ['csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm', 'pdf'];

    const filteredFiles = files.filter(file => {
      const extension = file.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(extension);
    });

    setSelectedImageFiles(prevFiles => [...prevFiles, ...filteredFiles]);

    const invalidFiles = files.filter(file => !allowedExtensions.includes(file.name.split('.').pop().toLowerCase()));

    if (invalidFiles.length > 0) {
      setAlertMessage(`Invalid file(s) detected: ${invalidFiles.map(file => file.name).join(', ')}. Only pdf files are allowed.`);
    } else {
      setAlertMessage('');
    }
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };
  const handleDestinationSubCategories = (e) => {
    const value = e.target.value;
    setSelectedDestinationSubCategories(value);
    // if (value) setErrors(prev => ({ ...prev, selectedBrand: null }));
};
const handleDrop = (e) => {
  e.preventDefault();
  setDragging(false);

  const files = Array.from(e.dataTransfer.files);
  const allowedExtensions = ['csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm', 'pdf'];
  
  const filteredFiles = files.filter(file => {
    const extension = file.name.split('.').pop().toLowerCase();
    return allowedExtensions.includes(extension);
  });

  setSelectedImageFiles(prevFiles => [...prevFiles, ...filteredFiles]);

  const invalidFiles = files.filter(file => !allowedExtensions.includes(file.name.split('.').pop().toLowerCase()));

  if (invalidFiles.length > 0) {
    setAlertMessage(`Invalid file(s) detected: ${invalidFiles.map(file => file.name).join(', ')}. Only PDF files are allowed.`);
  } else {
    setAlertMessage('');
  }
};
  
  const handleSubmitFileUpload  = () => {
    setLoadingButton(true)
    console.log(handleLinkFile);
    if (selectedImageFiles.length < 1 && selectedGraphicFiles.length < 1) {
      setLoadingButton(false)
        return true
    }
    console.log(props.subCategoryId);
    console.log(props.assetIdentifier);
    console.log(props.assetCategory);
    // return true

    const data = new FormData();
    const graphicData = new FormData();

    data.append("integerId", props.selectedProjectData.integerId);
    data.append("assetCategory",props.selectedSubCategories? props.selectedSubCategories.assetCategory:'');
    // data.append("assetSubCategory", props.subCategoryId? props.subCategoryId:''); subCategoryId subCategoryId
    data.append("subCategoryId", props.selectedSubCategories? props.selectedSubCategories.id:'');
    data.append("projectId", props.selectedProjectData.projectId? props.selectedProjectData.projectId:'');
    data.append("assetIdentifier", props.assetIdentifier? props.assetIdentifier:'');
    data.append("notes", '');
    data.append("asinList", asinList? asinList:'');
    data.append("assetUrl",assetUrl?assetUrl:'');
    data.append("destinationSubCategories",selectedDestinationSubCategories?selectedDestinationSubCategories:'');
    data.append("status",7)


    if (selectedImageFiles.length > 0) {
      // data.append("fileType", 'Image');
      for (let i = 0; i < selectedImageFiles.length; i++) {
        data.append("attachmentFiles", selectedImageFiles[i]);
      }
      if (selectedGraphicFiles.length < 1) {
        data.append("attachmentFiles1", 0);
      }
      if (handleLinkFile != false) {
        data.append("handleLinkFile", handleLinkFile);
      }
      else {
        data.append("handleLinkFile", 0);
      }
    }

    if (selectedGraphicFiles.length > 0) {
      for (let i = 0; i < selectedGraphicFiles.length; i++) {
        data.append("attachmentFiles1", selectedGraphicFiles[i]);
      }
      if (selectedImageFiles.length < 1) {
        data.append("attachmentFiles", 0);
        data.append("handleLinkFile", 0);
      }
    }

    UploadCMAssetsService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
        setSelectedImageFiles([])
        setSelectedGraphicFiles([])
        setHandleLinkFile(false)
        props.setFileListOfAssets(res.fileList)
        if(props.flagNumber===10){
          props.setAllFileListOfAssets(res.fileList)
        }
        if (res.assetStatusCount) {
          props.setAssetsStatusCount(res.assetStatusCount);
        }
        props.handleBackFromUploadAssets(res,2)
        setLoadingButton(false)
        props.setFiles(res.fileList)

      }
    })
  };

  const handleSubmitOnlineDoc = () => {
    setLoadingButton(true);
  
    if (!assetUrl) {
      setLoadingButton(false);
      return;
    }
  
    const data = {
      integerId: props.selectedProjectData.integerId,
      projectId: props.selectedProjectData.projectId || '',
      assetIdentifier: props.assetIdentifier || '',
      assetCategory: props.selectedSubCategories ? props.selectedSubCategories.assetCategory : '',
      subCategoryId: props.selectedSubCategories ? props.selectedSubCategories.id : '',
      assetUrl,
      destinationSubCategories: selectedDestinationSubCategories || '',
      asinList: asinList && asinList.length > 0 ? asinList : '',   
      notes: '',
      status: 8,
      actualFileName: fileName,
    };
  
    UploadCMOnlineDocService(props.token, data).then((res) => {
      if (res) {
        props.setFileListOfAssets(res.fileList);
        if (props.flagNumber === 10) {
          props.setAllFileListOfAssets(res.fileList);
        }
        if (res.assetStatusCount) {
          props.setAssetsStatusCount(res.assetStatusCount);
        }
        props.handleBackFromUploadAssets(res, 2);
        props.setFiles(res.fileList);  
      }
      setLoadingButton(false);
    });
  };
  

  const handleSelectProduct=()=>{
    setStoreName(props.selectedProjectData.storeName);
    let data={
        // integerID:intergerId
        asinList:props.selectedProjectData.asin,
          projectId: props.selectedProjectData.projectId,
          integerID: props.selectedProjectData.integerId
    }
    FetchCMProductDataService(props.token,data).then((res)=>{
        if(res){
            console.log(res)
            setProductList(res.productsList)
            setAddProductsPopup(true)
        }
    })
  } 
  return (
    <>
      <Card className='p-2'>
      <Row>
          <Col>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <button
                  onClick={() => props.handleBackFromUploadAssets(1)}
                  className="back-btn mr-2"
                >
                  <img src={BackButton} alt="Back" />
                </button>

                <b className="mr-3">{props.assetIdentifier} Assets</b>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
        <Col md={6}>
          <div className="ml-2 mt-2">
            <div className="form-check mt-2">
              <input
                className="form-check-input"
                type="radio"
                name="uploadOption"
                id="onlineDocument"
                value="onlineDocument"
                checked={uploadOption === 'onlineDocument'}
                onChange={() => {
                  setUploadOption('onlineDocument');
                  setSelectedImageFiles([]);
                  setSelectedGraphicFiles([]);
                  setAlertMessage('');
                  setIsCheckedImg(false);
                  setIsCheckedAi(false);
                }}
              />
              <label className="form-check-label" htmlFor="onlineDocument">
                <b>Online Document</b>
              </label>
              {uploadOption === 'onlineDocument' && (
              <Row className="align-items-center ml-1 mb-2 mt-3">
                <Col md={4} className="mt-2">
                  <label><b>File Name :</b></label>
                </Col>
                <Col md={8}>
                  <input
                    type="text"
                    placeholder="Enter File Name"
                    className="form-control h-75"
                    value={fileName}
                    onChange={(e) => setFileName(e.target.value)}
                  />
                </Col>
                <Col md={4} className="mt-3">
                  <label><b>Online Document Link :</b></label>
                </Col>
                <Col md={8} className="mt-2">
                  <input
                    type="text"
                    placeholder="Enter Online Document Link"
                    className="form-control h-75"
                    value={assetUrl}
                    onChange={handleAssetUrlChange}
                    onBlur={() => setOnlineDocumentLink(true)}
                  />
                  {onlineDocumentLink && assetUrl.trim() !== '' && !isValidAssetUrl && (
                    <div className="text-danger mt-1">
                      Please enter a valid Link.
                    </div>
                  )}
                </Col>
              </Row>
            )}
            </div>
            <div className="form-check mt-3">
              <input
                className="form-check-input"
                type="radio"
                name="uploadOption"
                id="uploadAssets"
                value="uploadAssets"
                checked={uploadOption === 'uploadAssets'}
                onChange={() => {
                  setUploadOption('uploadAssets');
                  setIsCheckedImg(true); 
                  setAssetUrl('');
                  setFileName('');
                  setIsValidAssetUrl(true);
                  setOnlineDocumentLink(false);
                }}
              />
              <label className="form-check-label" htmlFor="uploadAssets">
                <b>Upload Assets</b>
                <p className="ml-4">
                  Supported File Types: 'csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm', 'pdf'
                </p>
              </label>
            </div>
          </div>
          {uploadOption === 'uploadAssets' && (isCheckedImg || isCheckedAi) && (
            <Row className="justify-content-between mt-3">
              <Col md={10} className="p-4 ml-4 dotted-box-upload-product">
                <div
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                >
                  <label
                    htmlFor="fileInput"
                    className={`custom-brand-file-input text-center uploadfile ${dragging ? "dragging" : ""}`}
                  >
                    <h5>
                      <FontAwesomeIcon icon={faCloudUploadAlt} style={{ fontSize: "30px" }} />
                    </h5>
                    <h5>Drag & Drop Files</h5>
                    <h5>OR</h5>
                    <input
                      type="file"
                      id="fileInput"
                      name="ticketAttachment"
                      className="custom-brand-file"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      multiple
                    />
                    <Button onClick={() => document.getElementById("fileInput").click()} style={{ background: "#B2A1FF" }}>
                      Browse Files
                    </Button>
                  </label>
                  <p style={{ color: 'red' }}>{alertMessage}</p>
                  <p style={{ fontSize: "13px" }}>Attached File List</p>
                  <ul style={{ color: "green", fontSize: "13px" }}>
                    {selectedImageFiles.length > 0 ? (
                      selectedImageFiles.map((file, index) => (
                        <li key={index}>
                          {file.name}
                          <button className="btn" onClick={() => handleRemoveFile(file)}>
                            <FontAwesomeIcon color="red" size="15px" icon={faWindowClose} />
                          </button>
                        </li>
                      ))
                    ) : (
                      <li>No files attached</li>
                    )}
                  </ul>
                </div>
              </Col>
            </Row>
          )}         
        </Col>
          <Col md={6} className="mt-5">
          <Row className="align-items-center ml-1 mt-1">
              <Col md={4}>
                <label><b>Destination Category :</b></label>
              </Col>
              <Col md={8}>
                <select
                  className="form-control h-75"
                  value={selectedDestinationSubCategories}
                  onChange={handleDestinationSubCategories}
                >
                  <option value="">--Select--</option>
                  {props.filterSubcategoryList &&
                    props.filterSubcategoryList.map((subCategory) => (
                      <option key={subCategory.id} value={subCategory.id}>
                        {subCategory.subCategoryName}
                        {" "}
                        ({subCategory.assetCategory__categoryName})
                      </option>
                    ))}
                </select>
              </Col>
            </Row>
          <Row className="ml-1 mb-2 mt-2">
              <Col md={4}>
                <label>
                  <b>ASIN List :</b>
                </label>
                        <div
                          style={{
                            maxHeight: "105px",
                            overflowY: "auto",
                          }}
                        >
                          {(Array.isArray(asinList)
                            ? asinList
                            : typeof asinList === 'string'
                            ? asinList.split(',')
                            : []
                          ).map((asin, index) => (
                            <div key={index}>{asin}</div>
                          ))}
                        </div>
                        </Col>
                        <Col md={8}>
                        <Button
                        className="btn-background-color w-100"
                        onClick={() => { handleSelectProduct() }}
                        disabled={(!selectedImageFiles || selectedImageFiles.length === 0) && !assetUrl}
                      >
                        Add ASINs
                        <img className='ml-2 mb-1' src={NewTaskIcon} style={{ height: '18px' }} />
                      </Button></Col>
                
          </Row>
          </Col>
        </Row>
       
        <Row>
          <Col md={12}>
            <div className="d-flex justify-content-center">
            {uploadOption === 'onlineDocument' ? (
          <Button
            className="btn-background-color-Proceed-gallery"
            disabled={
              !assetUrl.trim() || 
              !isValidAssetUrl || 
              loadingButton || 
              !fileName.trim()
            }
            onClick={handleSubmitOnlineDoc}
          >
            {loadingButton ? 'Submitting...' : 'Submit'}
          </Button>
        ) : (
          (isCheckedImg || isCheckedAi) && (
            <Button
              className="btn-background-color-Proceed-gallery"
              disabled={(selectedImageFiles.length < 1 && selectedGraphicFiles.length < 1) || loadingButton}
              onClick={handleSubmitFileUpload}
            >
              {loadingButton ? 'Submitting...' : 'Submit'}
            </Button>
          )
        )}
            </div>
          </Col>
        </Row>
        <CustomModal
          header={
            <span>
              Add ASINs for :  <b>{ storeName || ''}</b>
            </span>
          }
        isOpen={addProductsPopup}
        toggle={() => {
            setAddProductsPopup(!addProductsPopup)
        }}
        size={"lg"}
       className='my-task-custom-module'
      >
        <NewCMProductListScreen
        documentScreen={false}
        selectedProjectData= {props.selectedProjectData}
        selectedSubCategories ={props.selectedSubCategories}
         selectedImage={selectedImageFiles}
         setFileListOfAssets={props.setFileListOfAssets}
         setSelectedImage={setSelectedImageFiles}
        //  selectedStatus={selectedStatus}
        //  setSelectedStatus={setSelectedStatus}
        setAddProductsPopup={setAddProductsPopup}
        asinList={asinList}
        singleSelect={true}
        setAsinList={setAsinList}
        // setSelectedAsin={setSelectedAsin}
        action={true}
        productList={productList}
        />
      
      </CustomModal>
      </Card>
      
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
    storeOverview: state.accountOverview.store.storeOverview,
  };
};

export default connect(mapStateToProps)(UploadAllTypeOfPDAssetsFile)